<template>
  <div class="app">
    <AdView />
    <ShortCut />
  </div>
</template>
<script>
import AdView from '@/components/frontlayout/AdView'
import ShortCut from '@/components/frontlayout/ShortCut'
export default {
  name: 'FMain',
  components: {
    AdView,
    ShortCut
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontlayout/FMain.vue